import firebase from "firebase/app";
require("firebase/firestore");
// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDWw4vtsj2NzoLeV4kZErP9esZlDSlvrmw",
  authDomain: "real-time-chat-fe76c.firebaseapp.com",
  databaseURL: "https://real-time-chat-fe76c.firebaseio.com",
  projectId: "real-time-chat-fe76c",
  storageBucket: "",
  messagingSenderId: "453409057518",
  appId: "1:453409057518:web:3d2d5df0ad4e756c"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export default firebaseApp.firestore();
